module.exports = __webpack_public_path__ + "img/3.87d966d4.png";